import { CATEGORY_COPY, CONTENT_PAGES, MEDIA, SITE } from '@/data/site';
import type { CmsState } from '@/types/cms';

export const DEFAULT_CMS: CmsState = {
  version: 1,
  site: {
    ...SITE,
    announcement: ['משלוח חינם ומבוטח','30 ימי החזרה והחלפה','עד 12 תשלומים ללא ריבית','ייעוץ אישי ללא עלות'],
  },
  home: {
    hero: {
      kicker: 'תכשיטים עם משמעות',
      title: 'יהלומים שנוצרו\nלעולם החדש.',
      intro: 'תכשיטים על־זמניים, בחירה מודעת ונוכחות אלגנטית בכל רגע.',
      image: MEDIA.homeHeroV713,
      primaryLabel: 'קנו את הקולקציות ←',
      primaryTo: '/catalog',
      secondaryLabel: 'לתיאום פגישה',
      secondaryTo: '/appointments',
    },
    serviceWays: {
      eyebrow: 'PRIVATE APPOINTMENT & ONLINE SERVICE',
      title: 'אונליין. פגישה אישית.\nהדרך שלכם.',
      intro: 'נפגשים בבוטיק, משוחחים בווידאו או בוחרים אונליין — עם ליווי אישי לכל אורך הדרך.',
      image: MEDIA.serviceWaysV716,
      onlineTitle: 'אונליין',
      onlineText: 'גלשו, בחרו והזמינו בביטחון מלא.',
      appointmentTitle: 'פגישה אישית',
      appointmentText: 'בוטיק פרטי, זמן שמוקדש רק לכם.',
      remoteTitle: 'שירות מרחוק',
      remoteText: 'ייעוץ בווידאו וליווי אישי, מהנוחות של הבית.',
      ctaLabel: 'לתיאום פגישה ←',
    },
  },
  categories: structuredClone(CATEGORY_COPY),
  pages: structuredClone(CONTENT_PAGES),
  updatedAt: new Date(0).toISOString(),
};
